import _ from '@lodash';
import React, { useState } from 'react';
import { RiFolderUploadFill } from 'react-icons/ri';

import { IconButton, Tooltip, TableCell } from '@material-ui/core';
import EntriesDialog from './EntriesDialog';

function EntriesButton(props) {
	const [showDialog, setShowDialog] = useState(false);

	const isType = () => {
		return (props.item.type && props.item.type && (props.item.type === 'ANN' || props.item.type === 'HYSYS' || props.item.type === 'PETROSIM' || props.item.type === 'SPREADSHEET'));
	};

	return (
		<TableCell className='w-auto text-center' padding='none'>

			<Tooltip title={isType() ? 'Entries' : 'No entries available for type'}>
				<span>
					<IconButton onClick={e => { setShowDialog(true); e.preventDefault(); }} disabled={!isType()}>
						<RiFolderUploadFill className='text-base' />
					</IconButton>
				</span>
			</Tooltip>

			{showDialog && (<EntriesDialog
				item={props.item}
				onCancel={() => setShowDialog(false)}
			// onSave={result => { setShowDialog(false); }}
			/>)}

		</TableCell>
	);
}

export default EntriesButton;
